<template>
    <div class="body" :class="classes">
        <slot name="body"></slot>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component({})
    export default class CoreAccordionContent extends Vue {
        @Prop({ default: '' }) public additionalClasses!: string;

        public isShown: boolean = false;

        public mounted() {
            this.$nextTick(() => {
                this.isShown = true;
            });
        }

        public get classes() {
            return [this.additionalClasses, { shown: this.isShown }];
        }

        public beforeDestroy() {
            this.isShown = false;
        }
    }
</script>

<style lang="less" scoped>
    .body {
        width: 100%;

        > * {
            .generic-transition();

            will-change: transform;
            transform: translateY(-10px);
            opacity: 0;
        }

        &.shown {
            > * {
                .generic-transition();

                will-change: transform;
                transform: translateY(0);
                opacity: 1;
            }
        }
    }
</style>
